<app-navbar></app-navbar>


<div class="affaires">
    <button (click)="router.navigate(['lots'])">
        <mat-icon>arrow_back</mat-icon>
        Retour aux lots
    </button>
  <div class="header">
    <div class="spinner-container">
      <mat-progress-spinner
        *ngIf="isLoading"
        mode="indeterminate"
        diameter="30"
        class="spinner">
      </mat-progress-spinner>
      <h1>Lot {{ currentLotID }}:</h1>
      <h2>{{ affairesCount }} affaire(s) trouvée(s)</h2>
    </div>
    <div>
      <div class="inputs-contenair">
          <input [(ngModel)]="searchString" (ngModelChange)="updateSearchString($event)" placeholder="Recherche par nom, adresse, code postal..." />
      </div>
    </div>
  </div>
  <div>
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <ng-container matColumnDef="plus">
          <th mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let row">
            <button (click)="setCurrentAffaireProducts(row.id)" class="plus-btn">+</button>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Réference NRJ Diags</th>
          <td mat-cell *matCellDef="let row">{{ row.mlRef }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Noms et Prénoms</th>
          <td mat-cell *matCellDef="let row">{{ row.finalCustomerLastname }}</td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>Adresse</th>
          <td mat-cell *matCellDef="let row">{{ row.workSiteFullAddress }}</td>
        </ng-container>

        <ng-container matColumnDef="latestDocument">
          <th mat-header-cell *matHeaderCellDef>Rapport</th>
          <td mat-cell *matCellDef="let row">
            <button (click)="downloadLatestDocument(row.affairsDocumentsDelivered)" *ngIf="row.affairsDocumentsDelivered.length >= 1">Télécharger</button>
            <p *ngIf="row.affairsDocumentsDelivered.length === 0">Aucun document délivré</p>
          </td>
        </ng-container>

          <ng-container matColumnDef="navigate">
              <th mat-header-cell *matHeaderCellDef>Détails</th>
              <td mat-cell *matCellDef="let row">
                  <button (click)="navigateToAffair(row.mlRef)">Détails</button>
              </td>
          </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <div class="details">
        <div class="row">
          <div *ngFor="let product of currentAffaireProducts" class="col-md-4">
            <div *ngIf="product.product.name !== null" class="product-contenair">
              <div class="product-header" [style.background-color]="product.productStatus?.color !== null ? product.productStatus.color : '#ccc'">
              <p>{{ product.product.name }}</p>
                <div class="product-quantity">
                  x{{ product.quantity }}
                </div>
              </div>
              <div class="product-body">
                <p>Reçu le: {{ product.dateReceiptFormatted }}</p>
                <p>Réalisé le: {{ product.dateRealisationFormatted === null ? 'N/A' : product.dateRealisationFormatted }}</p>
              </div>
              <div class="product-status">
                {{ product.productStatus.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
